import { useOktaAuth } from '@okta/okta-react';

export function useIsAdmin() {
  const { authState } = useOktaAuth();
  if (!authState?.isAuthenticated) return false;
  const roles = authState?.accessToken?.claims?.roles ?? [];
  return Array.isArray(roles) && roles.includes('orion_admin');
}
